var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.303,
    height: 31.404,
    viewBox: "0 0 24.303 31.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2755",
    "data-name": "\\uADF8\\uB8F9 2755",
    transform: "translate(-37.85 -591.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_47",
    "data-name": "\\uD569\\uCE58\\uAE30 47",
    d: "M3248.908-5761.6h-19.514a2.389,2.389,0,0,1-2.394-2.378v-26.647a2.389,2.389,0,0,1,2.394-2.378h10.857v10.812H3251.3v18.214A2.389,2.389,0,0,1,3248.908-5761.6Zm-19.514-29.4a.382.382,0,0,0-.394.378v26.647a.382.382,0,0,0,.394.378h19.514a.382.382,0,0,0,.394-.378v-16.214H3238.25V-5791Zm21.908,7.351h-9.434V-5793h1.355a2.392,2.392,0,0,1,1.688.688l5.687,5.631a2.381,2.381,0,0,1,.7,1.682Zm-7.434-2h4.93l-4.93-4.881Z",
    transform: "translate(-3189.151 6384.596)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "translate(47 616)",
    fill: "currentColor",
    fontSize: 10,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1426",
    "data-name": "\\uC0AC\\uAC01\\uD615 1426",
    d: "M1,1V2H6V1H1M0,0H7V3H0Z",
    transform: "translate(41 595)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1427",
    "data-name": "\\uC0AC\\uAC01\\uD615 1427",
    d: "M1,1V2H6V1H1M0,0H7V3H0Z",
    transform: "translate(41 599)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.00b4b5e400b7424748a6b2cb204ef5ad.svg";
export { ForwardRef as ReactComponent };